<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <img class="login-logo" [src]="logoUrl$ | async" alt="">
    <!-- <h3>{{ "i18n.base.login.header" | translate }}</h3> -->
    <div class="e-card">
      <div class="e-card-content">
        <form id="loginForm" [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="on">
          <div class="form-group">
            <label for="userName">{{ "i18n.base.login.userName" | translate }}</label>
            <input id="userName" name="username" type="text" autocomplete="username" class="form-control" placeholder="{{ 'i18n.base.login.userName' | translate }}" formControlName="userName">
            <app-error-messages [control]="loginUserNameControl"></app-error-messages>
          </div>
          <div class="form-group">
            <label for="password">{{ "i18n.base.login.password" | translate }}</label>
            <app-password-input inputId="password"
                                name="password"
                                autocomplete="current-password"
                                placeholder="{{ 'i18n.base.login.password' | translate }}"
                                formControlName="password">
            </app-password-input>
            <app-error-messages [control]="loginPasswordControl"></app-error-messages>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="submit" class="btn btn-primary order-2">
              @if (loading) {
                <div class="spinner-border spinner-border-sm me-3" role="status"></div>
              }
              {{ "i18n.base.login.login" | translate }}
            </button>
            <a class="btn btn-link order-1" [routerLink]="[forgotPasswordRoute]">
              {{ "i18n.base.login.forgot-password" | translate }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
